const Role = {
  path: "",
  redirect: "/manageRole",
  name: "",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/manageRole",
      redirect: "/manageRole",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Role",
      meta: {
        requiresAuth: true,
        activeUrl: "/manageRole",
        parent: "permission",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/manageRole"),
          meta: {
            requiresAuth: true,
            activeUrl: "/manageRole",
            parent: "permission",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Role Detail",
          component: () => import("@/views/pages/manageRole/Detail.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/manageRole",
            parent: "permission",

            lv: 2,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Role;
